import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home/Home.vue'
import Login from '@/views/Login/Login.vue'
import Recipe from '@/views/Recipe/Recipe.vue'
import RecipeDetail from '@/views/RecipeDetail/RecipeDetail.vue'
import Settings from '@/views/Settings/Settings.vue'
import RecipeEdit from '@/views/RecipeEdit/RecipeEdit.vue'
import { useUserStore } from '@/stores/userStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/recipes',
      name: 'recipe',
      component: Recipe,
    },
    {
      path: '/recipes/:id',
      name: 'recipeDetail',
      component: RecipeDetail,
      props: true,
    },
    {
      path: '/recipes-edit/:id',
      name: 'recipeEdit',
      component: RecipeEdit,
      props: true,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  if (to.path !== '/login') {
    const userStore = useUserStore()
    await userStore.checkLogin()
    next()
  } else {
    next()
  }
})

export default router
